import type { ReactNode } from 'react'
import { ExternalLink } from 'lucide-react'
import { pathOf, truncateMiddle } from '@/lib/format'

/**
 * A drawer's read-only rows: what the crawl extracted and the team does not
 * edit. Wrap them in a `<dl>`. A null value shows as a dash.
 */
export function Detail({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="grid grid-cols-[130px_1fr] gap-3 text-[13px]">
      <dt className="text-ink-faint">{label}</dt>
      <dd className="min-w-0">{children ?? <span className="text-ink-faint">—</span>}</dd>
    </div>
  )
}

export function DetailLink({ url }: { url: string }) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      title={url}
      className="inline-flex items-center gap-1 font-mono text-[12px] text-brand-blue hover:underline"
    >
      {truncateMiddle(pathOf(url), 40)}
      <ExternalLink size={11} aria-hidden />
    </a>
  )
}
